// src/plugins/sentryUserTracker.js
import { useAuthStore } from '@/stores/auth';
import * as Sentry from "@sentry/vue";

export function initSentryUserTracking() {
    const authStore = useAuthStore();

    // Check if the store rehydrated a user session from LocalStorage
    if (authStore.isLoggedIn && authStore.userId) {
        console.debug('Restoring Sentry User Context from persisted state');

        Sentry.setUser({
            id: authStore.userId,
            username: authStore.userName,
            email: authStore.userId,
        });
    }
}
